import { Component } from 'react'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import { refreshToken } from '../actions/authenticationJwtActions'
import {
  getAuthentication,
  getUserFingerPrint,
  tempoAquisicaoTokenEmMinutos
} from '../security/securityContext'

const PERIODO_VERIFICACAO_TOKEN = 300 // em segundos
const TEMPO_LIMITE_PARA_REFRESH = 50 // em minutos

class AutoRefreshToken extends Component {
  componentDidMount() {
    setInterval(this.verificaNecessidadeAtualizarToken.bind(this), PERIODO_VERIFICACAO_TOKEN * 1000)
  }

  verificaNecessidadeAtualizarToken() {
    if (tempoAquisicaoTokenEmMinutos() > TEMPO_LIMITE_PARA_REFRESH) {
      const { refreshToken } = getAuthentication()
      const ufp = getUserFingerPrint()

      if (refreshToken && ufp) {
        this.props.refreshToken(refreshToken, getUserFingerPrint())
      }
    }
  }

  render() {
    return null
  }
}

const mapStateToProps = ({ authentication }) => ({ authentication })

const reduxEnhanced = connect(mapStateToProps, { refreshToken })(AutoRefreshToken)

export default withRouter(reduxEnhanced)
